import type { Option } from '@branchjs/neo-components';

export const DEFAULT_REDIRECT_OPTION: Option = { value: 'default', label: 'Default Redirect' };

export const WEB_REDIRECT_OPTION: Option = { value: 'web', label: 'Web URL' };

export const DEEPVIEW_REDIRECT_OPTION: Option = { value: 'deepview', label: 'Deepview' };

export const REDIRECT_OPTIONS: Option[] = [DEFAULT_REDIRECT_OPTION, WEB_REDIRECT_OPTION, DEEPVIEW_REDIRECT_OPTION];
